/**
 * /dashboard/accounting/contacts/new — Create contact (G_ACC3b).
 *
 * On success the ContactForm navigates to the detail page; cancel goes
 * back to the list.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/contacts/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ContactForm } from "@/components/accounting/contact-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/contacts/new",
)({
  component: NewContactRoute,
});

function NewContactRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="Add a Contact"
      description="Add a customer, vendor or employee contact."
    >
      <Card className="max-w-3xl">
        <CardContent className="pt-6">
          <ContactForm />
        </CardContent>
      </Card>
    </AccountingModuleShell>
  );
}
